const FEEDBACK_PENDING = 'feedback_pending';
const FEEDBACK_FAILED = 'feedback_failed';
const FEEDBACK_DOWNLOADED = 'feedback_downloaded';

export {
  FEEDBACK_PENDING,
  FEEDBACK_FAILED,
  FEEDBACK_DOWNLOADED,
};



// WEBPACK FOOTER //
// ./src/store/feedbacks/types.js